(() => {
  const escapeHtml = (value) =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const normalizeValue = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const splitValueLines = (key, value) => {
    const raw = String(value || '').trim();
    if (!raw) {
      return [];
    }

    if (key === 'optionExamples') {
      return raw.split(/\s*;\s*/).map((line) => line.trim()).filter(Boolean);
    }

    if (key === 'configurator' || key === 'colors') {
      return raw.split(/\s*,\s*/).map((line) => line.trim()).filter(Boolean);
    }

    if (key === 'power' && raw.includes('. ')) {
      return raw.split(/\.\s+(?=[A-Z])/).map((line) => line.trim().replace(/\.$/, '')).filter(Boolean);
    }

    return raw.split(/\n+/).map((line) => line.trim()).filter(Boolean);
  };

  const formatValue = (key, value) => {
    const lines = splitValueLines(key, value);

    if (!lines.length) {
      return '<span class="varg-specs-compare__muted">-</span>';
    }

    if (lines.length === 1) {
      return `<span class="varg-specs-compare__value-text">${escapeHtml(lines[0])}</span>`;
    }

    return `
      <div class="varg-specs-compare__value-stack">
        ${lines.map((line) => `<span class="varg-specs-compare__value-line">${escapeHtml(line)}</span>`).join('')}
      </div>
    `;
  };

  document.querySelectorAll('[data-varg-compare-root]').forEach((section) => {
    const dataNode = section.querySelector('[data-varg-model-data]');
    const pickerNode = section.querySelector('[data-varg-picker]');
    const heroNode = section.querySelector('[data-varg-hero]');
    const tableNode = section.querySelector('[data-varg-spec-table]');
    const tableStateNode = section.querySelector('[data-varg-table-state]');

    if (!dataNode || !pickerNode || !heroNode || !tableNode || !tableStateNode) {
      return;
    }

    let dataset;
    try {
      dataset = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    const models = dataset.models || {};
    const modelKeys = Object.keys(models);
    if (!modelKeys.length) {
      return;
    }

    const state = {
      primary: dataset.defaultModel && models[dataset.defaultModel] ? dataset.defaultModel : modelKeys[0],
      compare: '',
    };

    const readQueryState = () => {
      const params = new URLSearchParams(window.location.search);
      const requestedPrimary = params.get('model');
      const requestedCompare = params.get('compare');

      if (requestedPrimary && models[requestedPrimary]) {
        state.primary = requestedPrimary;
      }

      if (requestedCompare && models[requestedCompare] && requestedCompare !== state.primary) {
        state.compare = requestedCompare;
      }
    };

    const syncQueryState = () => {
      const url = new URL(window.location.href);
      url.searchParams.set('model', state.primary);

      if (state.compare) {
        url.searchParams.set('compare', state.compare);
      } else {
        url.searchParams.delete('compare');
      }

      window.history.replaceState({}, '', `${url.pathname}${url.search}`);
    };

    const renderPicker = () => {
      const compareOptions = modelKeys
        .filter((key) => key !== state.primary)
        .map(
          (key) => `<option value="${key}"${state.compare === key ? ' selected' : ''}>${escapeHtml(models[key].shortLabel)}</option>`
        )
        .join('');

      pickerNode.innerHTML = `
        <div class="varg-specs-compare__picker-shell">
          <div class="varg-specs-compare__picker-main">
            <p class="varg-specs-compare__section-kicker">Hauptmodell</p>
            <div class="varg-specs-compare__pill-row">
              ${modelKeys
                .map(
                  (key) => `
                    <button
                      type="button"
                      class="varg-specs-compare__pill${state.primary === key ? ' is-active' : ''}"
                      data-varg-model-pill="${key}"
                    >
                      ${escapeHtml(models[key].shortLabel)}
                    </button>
                  `
                )
                .join('')}
            </div>
          </div>
          <label class="varg-specs-compare__field">
            <span class="varg-specs-compare__field-label">Vergleichen mit</span>
            <select class="varg-specs-compare__select" data-varg-compare-select>
              <option value="">Kein Bike ausgewählt</option>
              ${compareOptions}
            </select>
          </label>
        </div>
      `;

      pickerNode.querySelectorAll('[data-varg-model-pill]').forEach((button) => {
        button.addEventListener('click', () => {
          state.primary = button.getAttribute('data-varg-model-pill') || state.primary;
          if (state.compare === state.primary) {
            state.compare = '';
          }
          render();
        });
      });

      const compareSelect = pickerNode.querySelector('[data-varg-compare-select]');
      if (compareSelect) {
        compareSelect.addEventListener('change', () => {
          state.compare = compareSelect.value && compareSelect.value !== state.primary ? compareSelect.value : '';
          render();
        });
      }
    };

    const renderHero = (primaryModel) => {
      heroNode.innerHTML = `
        <div class="varg-specs-compare__hero-card">
          <div class="varg-specs-compare__hero-copy">
            <p class="varg-specs-compare__eyebrow">${escapeHtml(primaryModel.categoryLabel)}</p>
            <h1 class="varg-specs-compare__hero-title">${escapeHtml(primaryModel.name)}</h1>
            <p class="varg-specs-compare__hero-subtitle">${escapeHtml(primaryModel.headline)}</p>
            <p class="varg-specs-compare__hero-summary">${escapeHtml(primaryModel.summary)}</p>
            <div class="varg-specs-compare__hero-actions">
              <a class="varg-specs-compare__button varg-specs-compare__button--primary" href="${escapeHtml(primaryModel.orderUrl)}">Jetzt bestellen</a>
            </div>
          </div>
        </div>
      `;
    };

    const renderTable = (primaryModel, compareModel) => {
      const columns = compareModel ? 3 : 2;
      let previousGroup = '';

      const rows = dataset.comparisonRows
        .map((row) => {
          const groupRow =
            row.group !== previousGroup
              ? `<tr class="varg-specs-compare__group-row"><th colspan="${columns}">${escapeHtml(row.group)}</th></tr>`
              : '';

          previousGroup = row.group;

          const primaryValue = primaryModel.table[row.key] || '';
          const compareValue = compareModel ? compareModel.table[row.key] || '' : '';
          const isDifferent = compareModel ? normalizeValue(primaryValue) !== normalizeValue(compareValue) : false;

          return `
            ${groupRow}
            <tr class="varg-specs-compare__data-row${isDifferent ? ' varg-specs-compare__data-row--different' : ''}">
              <th class="varg-specs-compare__row-label" scope="row">${escapeHtml(row.label)}</th>
              <td class="varg-specs-compare__value-cell">${formatValue(row.key, primaryValue)}</td>
              ${compareModel ? `<td class="varg-specs-compare__value-cell">${formatValue(row.key, compareValue)}</td>` : ''}
            </tr>
          `;
        })
        .join('');

      tableNode.innerHTML = `
        <div class="varg-specs-compare__table-wrap">
          <table class="varg-specs-compare__table">
            <thead>
              <tr>
                <th>Technische Daten</th>
                <th>${escapeHtml(primaryModel.shortLabel)}</th>
                ${compareModel ? `<th>${escapeHtml(compareModel.shortLabel)}</th>` : ''}
              </tr>
            </thead>
            <tbody>
              ${rows}
            </tbody>
          </table>
        </div>
      `;
    };

    const render = () => {
      const primaryModel = models[state.primary];
      const compareModel = state.compare ? models[state.compare] : null;

      renderPicker();
      renderHero(primaryModel);
      tableStateNode.textContent = compareModel
        ? `${primaryModel.shortLabel} und ${compareModel.shortLabel} im Direktvergleich`
        : 'Wähle ein weiteres Bike für den Direktvergleich.';
      renderTable(primaryModel, compareModel);
      syncQueryState();
    };

    readQueryState();
    render();
  });
})();